export const SearchGroup = {
  NAMES: "names",

  MEANING: "meaning",
} as const;

export type SearchGroupType = (typeof SearchGroup)[keyof typeof SearchGroup];

export const SEARCH_GROUPS: readonly SearchGroupType[] =
  Object.values(SearchGroup);
